import { useMutation, useQuery } from "@tanstack/react-query";
import { getCampaign, getCampaigns, resolveCampaign } from "../services/CampaignService";


// Hook
export const useCampaign = (code) => {
  return useQuery({
    queryKey: ["campaign", code],
    queryFn: () => getCampaign(code),
    enabled: !!code, // only run if code is provided
    staleTime: 1000 * 60 * 5, // 5minutes
    retry: 1, // retry once on failure
  });
};

export const useResolveCampaign = () => {
  return useMutation({
    mutationFn: ({ lat, lon }) => resolveCampaign(lat, lon),
  });
};

export const useGetCampaigns = () => {
  return useQuery({
    queryKey: ["available-campaigns"],
    queryFn: getCampaigns,
    staleTime: 1000 * 60 * 5, // 5 mins cache
    retry: 1,
  });
};